module.exports = __webpack_public_path__ + "media/hotel.b8b8c71b.jpg";